/* eslint-disable no-useless-escape */
/* eslint-disable no-undef */
import { initMultiScript } from "@/ultis/Helper";

export default class ConvivaService {
   constructor() {
      this.videojs = null;
      this.options = null;
      this.debug = process.env.VUE_APP_NODE_ENV !== "production";
      this.videoAnalytics = null;
      this.conviva = null;
   }

   checkOS(dataString, data) {
      let i = 0,
         j = 0,
         regex,
         regexv,
         match,
         matches,
         version;

      for (i = 0; i < data.length; i += 1) {
         regex = new RegExp(data[i].value, "i");
         match = regex.test(dataString);
         if (match) {
            regexv = new RegExp(data[i].version + "[- /:;]([\\d._]+)", "i");
            matches = dataString.match(regexv);
            version = "";
            if (matches) {
               if (matches[1]) {
                  matches = matches[1];
               }
            }
            if (matches) {
               matches = matches.split(/[._]+/);
               for (j = 0; j < matches.length; j += 1) {
                  if (j === 0) {
                     version += matches[j] + ".";
                  } else {
                     version += matches[j];
                  }
               }
            } else {
               version = "0";
            }
            return {
               name: data[i].name,
               brand: data[i].brand,
               version: parseFloat(version)
            };
         }
      }
      return { name: "unknown", version: 0 };
   }

   mobileAndTabletCheck() {
      let check = false;
      (function(a) {
         if (
            /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
               a
            ) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
               a.substr(0, 4)
            )
         )
            check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
   }

   getConvivaInstance() {
      return this.conviva;
   }

   loadScript(callback) {
      const baseUrl = `${process.env.BASE_URL}js`;
      initMultiScript(
         document,
         "script",
         [
            { id: "conviva-sdk", src: `${baseUrl}/conviva-core-sdk${this.debug ? ".debug.js" : ".js"}` },
            { id: "conviva-videojs-module", src: `${baseUrl}/conviva-videojs-module.js` }
         ],
         () => {
            if (callback) callback();
         }
      );
   }

   init(videojs, options = {}, callback) {
      this.videojs = videojs;
      this.options = options || {};
      this.loadScript(() => {
         this.initConviva();
         //Conviva.Analytics.reportDeviceMetric(Conviva.Constants.Network.CONNECTION_TYPE, "WiFi");
         if (callback) callback();
      });
   }

   initConviva() {
      if (this.debug) {
         let settings = {};
         settings[Conviva.Constants.GATEWAY_URL] = process.env.VUE_APP_CONVIVA_GATEWAY_URL;
         settings[Conviva.Constants.LOG_LEVEL] = Conviva.Constants.LogLevel.DEBUG;
         Conviva.Analytics.init(process.env.VUE_APP_CONVIVA_CUSTOMER_KEY, null, settings);
      } else {
         // production release
         Conviva.Analytics.init(process.env.VUE_APP_CONVIVA_CUSTOMER_KEY, null);
      }
      this.conviva = Conviva;
      //Create videoAnalytics object.
      this.videoAnalytics = Conviva.Analytics.buildVideoAnalytics();
      this.setDeviceMetadata();

      //Check if integrate videojs
      if (this.videojs) this.videoAnalytics.setPlayer(this.videojs);
      else this.setPlayerInfo();
   }

   setPlayerInfo() {
      const { FRAMEWORK_NAME, FRAMEWORK_VERSION } = Conviva.Constants;
      if (this.options.frameworkName) {
         var playerInfo = {};
         playerInfo[FRAMEWORK_NAME] = this.options.frameworkName;
         playerInfo[FRAMEWORK_VERSION] = this.options.frameworkVersion;
         this.videoAnalytics.setPlayerInfo(playerInfo);
      }
   }

   setDeviceMetadata() {
      let agent = [navigator.platform, navigator.userAgent, navigator.appVersion, navigator.vendor, window.opera].join(" "),
         os = this.checkOS(agent, [
            { name: "Windows Phone", value: "Windows Phone", version: "OS", brand: "Microsoft" },
            { name: "Windows", value: "Win", version: "NT", brand: "Microsoft" },
            { name: "iPhone", value: "iPhone", version: "OS", brand: "Apple" },
            { name: "iPad", value: "iPad", version: "OS", brand: "Apple" },
            { name: "Android", value: "Android", version: "Android", brand: "Google" },
            { name: "Mac", value: "Mac", version: "OS X", brand: "Apple" }
         ]);

      const { TYPE, CATEGORY, BRAND, MANUFACTURER, OS_NAME, OS_VERSION } = Conviva.Constants.DeviceMetadata;
      let deviceMetadata = {};
      // set the corresponding Conviva.Constants.DeviceType
      deviceMetadata[TYPE] = this.mobileAndTabletCheck() ? Conviva.Constants.DeviceType.MOBILE : Conviva.Constants.DeviceType.DESKTOP;
      deviceMetadata[CATEGORY] = Conviva.Constants.DeviceCategory.WEB;
      deviceMetadata[BRAND] = os.brand;
      deviceMetadata[MANUFACTURER] = os.brand;
      deviceMetadata[OS_NAME] = os.name;
      deviceMetadata[OS_VERSION] = os.version;

      Conviva.Analytics.setDeviceMetadata(deviceMetadata);
   }

   setContentInfo(contentInfo) {
      if (!contentInfo) return;
      this.videoAnalytics.setContentInfo(contentInfo);
   }

   reportPlaybackRequested({ streamUrl, isLive, duration, assetName, viewerId, defaultResource, ...rest }) {
      const { StreamType, STREAM_URL, ASSET_NAME, IS_LIVE, PLAYER_NAME, VIEWER_ID, DEFAULT_RESOURCE, DURATION } = Conviva.Constants;
      let contentInfo = {};
      if (!this.videojs) {
         contentInfo[STREAM_URL] = streamUrl;
         contentInfo[IS_LIVE] = isLive ? StreamType.LIVE : StreamType.VOD;
      }
      if (!this.videojs && !isLive) {
         contentInfo[DURATION] = duration;
      }
      contentInfo[ASSET_NAME] = assetName;
      contentInfo[PLAYER_NAME] = this.videojs ? "Video JS" : playerName || "JS Web";
      contentInfo[VIEWER_ID] = viewerId?.toString();
      contentInfo[DEFAULT_RESOURCE] = defaultResource;
      contentInfo[Conviva.Constants.APPLICATION_VERSION] = "1.0.0";

      this.videoAnalytics.reportPlaybackRequested({ ...contentInfo, ...rest });
   }

   reportPlaybackError(message) {
      this.videoAnalytics.reportPlaybackError(message, Conviva.Constants.ErrorSeverity.FATAL);
   }

   reportPlaybackEnded() {
      this.videoAnalytics.reportPlaybackEnded();
   }

   destroy() {
      this.videoAnalytics.reportPlaybackEnded();
      this.videoAnalytics.release();
      this.videoAnalytics = null;
      Conviva.Analytics.release();
      this.conviva = null;
   }
}
